import ApiClient from '@lib/apiClient';

const changeDetectorMiddleware = (store) => {
	let prevState = JSON.parse(JSON.stringify(store.getState().filterFieldStore));
	const excludedKeys = ['DETAILS_PAGE_FILTERS', 'clearAll', 'clearOne', 'trendResearchSearch', 'dateRange'];
	let debounceTimeout = null;
	let pendingAddedFields = new Set();
	let isOnTrendsPage = typeof window !== 'undefined' && window.location.pathname.startsWith('/trends');

	const sendTracker = (fields) => {
		try {
			let filterType = fields[0] === 'supplierCategoryList' ? 'fabricTypeList' : fields[0];
			ApiClient.POST('mixpanelAddEvent', { filterType: filterType }, 'TRENDS_APPLY_FILTER');
		} catch {}
	};

	const debounceSendTracker = () => {
		clearTimeout(debounceTimeout);
		debounceTimeout = setTimeout(() => {
			if (pendingAddedFields.size > 0 && isOnTrendsPage) {
				sendTracker(Array.from(pendingAddedFields));
				pendingAddedFields.clear();
			}
		}, 500);
	};

	return (next) => (action) => {
		const result = next(action);

		const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
		const nowOnTrends = currentPath.startsWith('/trends');

		if (isOnTrendsPage !== nowOnTrends) {
			isOnTrendsPage = nowOnTrends;
			pendingAddedFields.clear();
			clearTimeout(debounceTimeout);
			prevState = JSON.parse(JSON.stringify(store.getState().filterFieldStore));
			return result;
		}

		if (!isOnTrendsPage) return result;

		const newState = store.getState().filterFieldStore;
		const changedKeys = [];

		for (const key in newState) {
			if (excludedKeys.includes(key)) continue;

			const newValue = newState[key];
			const prevValue = prevState[key];
			const isArray = Array.isArray(newValue);

			if (!(key in prevState)) {
				changedKeys.push({ key, status: 'added' });
			} else if (isArray) {
				if (JSON.stringify(newValue) !== JSON.stringify(prevValue)) {
					changedKeys.push({ key, status: 'added' });
				}
			} else if (newValue !== prevValue) {
				changedKeys.push({ key, status: 'modified' });
			}
		}

		const addedKeys = changedKeys.filter((item) => item.status === 'added').map((item) => item.key);

		if (addedKeys.length > 0) {
			for (const key of addedKeys) {
				pendingAddedFields.add(key);
			}
			debounceSendTracker();
		}

		prevState = JSON.parse(JSON.stringify(newState));
		return result;
	};
};

export default changeDetectorMiddleware;
